export default __webpack_public_path__ + "static/media/Canadiens.f43fb689.png";